export const getCookie = (key) => {
    var cookie = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return cookie ? cookie.pop() : "";
};

export const clearForm = () => {
  // Clears ALL inputs displayed on screen
  const inputs = document.querySelectorAll('input');
  const textareas = document.querySelectorAll('textarea');
  const selects = document.querySelectorAll('select');

  inputs.forEach(input => {
    input.value = "";
  });

  textareas.forEach(area => {
    area.value = "";
  });

  selects.forEach(select => {
    select.options.selectedIndex = 0;
  });
};

export const acceptFiles = (runFiles, documents, sizeLimit) => {
  let totalSize = 0;

  runFiles.forEach(file => {
    totalSize += file.size;
  });

  if(totalSize < sizeLimit) {
    // New size
    return {accept: true, files: runFiles, size: totalSize}
  } else {
    // Current size
    return {accept: false, files: documents.files, size: documents.size}
  }
  
};

export const renameFile = (originalFile, newName) => {
  return new File([originalFile], newName, { type: originalFile.type, lastModified: originalFile.lastModified, });
};

export const logoutAYS = () => {
  let aysLogout;
  if (window.location.hostname === "localhost") {
    aysLogout = `${process.env.REACT_APP_AYS_URL}/OIDCLogout/Logout`;
  } else {
    aysLogout = `${process.env.REACT_APP_AYS_URL}/ays/OIDCLogout/Logout`;
  }
  sessionStorage.removeItem("appState");
  window.location.href = aysLogout;
};